var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewObjectTrack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_31",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20C6.53333 20 5.70833 19.6583 5.025 18.975C4.34167 18.2917 4 17.4667 4 16.5C4 15.5333 4.34167 14.7083 5.025 14.025C5.70833 13.3417 6.53333 13 7.5 13H18.5C19.4667 13 20.2917 13.3417 20.975 14.025C21.6583 14.7083 22 15.5333 22 16.5C22 17.4667 21.6583 18.2917 20.975 18.975C20.2917 19.6583 19.4667 20 18.5 20H7.5ZM7.5 18H18.5C18.9167 18 19.2708 17.8542 19.5625 17.5625C19.8542 17.2708 20 16.9167 20 16.5C20 16.0833 19.8542 15.7292 19.5625 15.4375C19.2708 15.1458 18.9167 15 18.5 15H7.5C7.08333 15 6.72917 15.1458 6.4375 15.4375C6.14583 15.7292 6 16.0833 6 16.5C6 16.9167 6.14583 17.2708 6.4375 17.5625C6.72917 17.8542 7.08333 18 7.5 18ZM5.5 11C4.53333 11 3.70833 10.6583 3.025 9.975C2.34167 9.29167 2 8.46667 2 7.5C2 6.53333 2.34167 5.70833 3.025 5.025C3.70833 4.34167 4.53333 4 5.5 4H16.5C17.4667 4 18.2917 4.34167 18.975 5.025C19.6583 5.70833 20 6.53333 20 7.5C20 8.46667 19.6583 9.29167 18.975 9.975C18.2917 10.6583 17.4667 11 16.5 11H5.5ZM5.5 9H16.5C16.9167 9 17.2708 8.85417 17.5625 8.5625C17.8542 8.27083 18 7.91667 18 7.5C18 7.08333 17.8542 6.72917 17.5625 6.4375C17.2708 6.14583 16.9167 6 16.5 6H5.5C5.08333 6 4.72917 6.14583 4.4375 6.4375C4.14583 6.72917 4 7.08333 4 7.5C4 7.91667 4.14583 8.27083 4.4375 8.5625C4.72917 8.85417 5.08333 9 5.5 9Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewObjectTrack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/view_object_track.cef20a8aabe9da86830953703a52d273.svg";